<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData">
      <div class="eval_data">
        <el-image class="like_img" :src="list.Details[0].TitImg" fit="contain"></el-image>
        <p>{{list.Details[0].Title}}</p>
      </div>
      <div class="eval_yn">
        <div :class="evaluate==1?'on':''" @click="evaluate=1"><span>{{ $t('base.good') }}</span></div>
        <div :class="evaluate==2?'on':''" @click="evaluate=2"><span>{{ $t('base.notGood') }}</span></div>
      </div>
      <el-input type="textarea" :placeholder="$t('alert.somethingYouSay')" resize="none" v-model="textarea" rows="3" maxlength="100" show-word-limit></el-input>
      <div slot="footer" class="dialog_footer">
        <el-button @click="handleClose">{{ $t('base.cancel') }}</el-button>
        <el-button type="primary" @click="Reviewed(list)">{{ $t('base.apply') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      evaluate: 1,
      textarea: ''
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {},
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'comment', false)
    },
    // 设置评价
    Reviewed(obj) {
      let that = this
      let data = { token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, OrderID: obj.ID, AppraisalType: 1, AppraisalStatus: that.evaluate, AppraisalContent: that.textarea }
      this.$post(this.$interface.SetAppraisal, qs.stringify(data)).then(res => {
        if (res.result != 0) {
          this.handleClose()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/comment.vue